import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { createSelector } from '@reduxjs/toolkit';
import { useNavigate } from 'react-router-dom';


const useRedirectEstablishmentActiveContent = (url) => {
    const navigate = useNavigate();
    const selectorProfile = createSelector(
        state => state.Profile,
        profile => ({
            establishmentActive: profile.establishmentActive
        })
    );
    const { establishmentActive } = useSelector(selectorProfile);

    useEffect(() => {
        if (establishmentActive) {
            navigate(url.replace('establishmentId', establishmentActive.item._id));
        }
    }, [establishmentActive]);
}

export default useRedirectEstablishmentActiveContent;